import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

//moment.tz.setDefault('UTC');
moment.suppressDeprecationWarnings = true;

moment.defaultFormat = process.env.VUE_APP_DATETIME_FORMAT;

export { moment };

export default Vue.use(VueMoment, {
  moment
});
